/*
* check is timestamp seconds or milliseconds and return in milliseconds
* reason:
* iOS team create timestamp in seconds
* web team create timestamp in milliseconds by `database.ServerValue.TIMESTAMP`
* */

export const normalizeTimestamp = (timestamp: number): number => (
  timestamp === Math.round(timestamp)
    ? timestamp
    : Math.round(1000 * timestamp)
);
